export default "__VITE_ASSET__CyNgl8pY__"